import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=d86bc8fc"
import script from "./statistic.vue?vue&type=script&lang=js"
export * from "./statistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports